import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    variants: {
        variant: {
            primaryGhost: 'text-primary-500 hover:text-primary-700 underline underline-offset-4',
            ghost: 'text-gray-400 hover:text-red-600 underline underline-offset-4'
        }
    }
} satisfies NuxtUiTheme['link'];
